// extracted by mini-css-extract-plugin
export default {"mainInput":"MainInput_mainInput__BHba9","mainInput__input":"MainInput_mainInput__input__5Nuot"};